import * as e from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/ShieldStar.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(a, { ref: t, ...r, weights: i }));
o.displayName = "ShieldStarIcon";
const s = o;
export {
  s as ShieldStar,
  o as ShieldStarIcon
};
